@let isFullAccess = (accessService.userPlan | async) === SubscriptionPlans.FULL_ACCESS;

<div class="choose-type-form">

  <p class="reports-disclaimer">
    <span>All the key data, in one place</span>
    <span>Our reports transform complex local data into clear, easy-to-understand visuals—helping you make smarter decisions whether you're looking for a place to live, invest, or grow your business.</span>
  </p>

  <app-custom-radio-group class="checkbox-container"
                          [style.grid-template-columns]="gridCols"
                          [appEqualizeCardsHeight]="['.control-block', '.features-list', '.additional-info']"
                          [featuresListMinMaxHeight]="['70px', '262px']">
    <ng-container *ngFor="let report of reportData">
    <app-type-card
      *ngIf="!report.forInnerUse || (accessService.getIsAdmin() || isFullAccess)"
        [readyToOrder]="readyToOrdersReports.includes(report.id)"
        (selectType)="handleActiveSelectionChange($any($event))"
        (featureExtended)="onFeatureExtended()"
        [isSelected]="selectedCheckbox === report.id"
        [isHeightIncreased]="reportData.length > 4"
        [cardType]="'REPORTS'"
        [data]="report">
      </app-type-card>
    </ng-container>

  </app-custom-radio-group>
</div>
<div class="button-wrapper">
  <button (click)="handleNextStep()" [disabled]="!selectedCheckbox" class="gradient-button">{{isSelectedReportReadyToOrder ? 'Next step' : "Contact us" }}</button>
</div>
